export const EXTERNAL_SVG = "assets/external.svg";
export const CLOSE_SVG = "assets/close.svg"; 
export const RIGHT_ARROW_SVG = "assets/right-arrow.svg";
export const EXTERNAL_BLACK_SVG = "assets/external-black.svg";
export const SORT_SVG = "assets/sort.svg";